<template>
  <div>

    <div class="page-box">
  
      <el-form
        class="form-box"
        label-position="top"
        label-width="80px"
        :model="formLabelAlign"
      >
        <div v-for="(item, index) in formLabelAlign.unitIds" :key="index">
          <el-row :gutter="20" type="flex" align="middle">
            <el-col :span="20">
              <div>
                  <div class="label-text">問題{{ index + 1 }} - 標題</div>
              </div>
              
              <el-form-item >
                <el-input
                  v-model="item[`title`]"
                  placeholder="請輸入標題"
                ></el-input>
              </el-form-item>
              <div>
                  <div class="label-text">問題{{ index + 1 }} - 答案</div>
              </div>
              <el-form-item>
                <Tinymce v-model="item[`answer`]" ref="Tinymce"></Tinymce>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <i @click="onClose(index)" class="el-icon-close" />
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div
            class="plus-outline-add text-line-button cursor-pointer"
            @click="onAdd"
          >
            <i class="icon iconfont icon-jiahao" /> 添加更多問題
          </div>
        </el-form-item>
      </el-form>
   
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
export default {
  components: { Tinymce },
  props:{
    list:{
      type:Array,
      default:()=>[]
    }
  },
  watch:{
    list:{
      handler(val){
         this.formLabelAlign.unitIds = val;
      },
      deep:true,
      immediate:true
      
    }

  },
  data() {
    return {
      formLabelAlign:{
         unitIds:[]
      } 
    };
  },
  created() {
    this.formLabelAlign.unitIds = this.list;
  },
  methods: {
    onAdd(){
      this.formLabelAlign.unitIds.push({
        question:'',
        answer:'',
        lang:0,
        type:0
      })
    },
      onClose(index){
        this.formLabelAlign.unitIds.splice(index,1)
      }
  }
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
.form-box {
}
.unit-list {
  margin-bottom: 20px;
}
.plus-outline-add {
  display: inline-block;
}
</style>